import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/HomePage/Home';
import Policy from './Pages/PrivacyPolicy/Policy';
import Terms from './Pages/PrivacyPolicy/Terms';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home/>}> </Route>
        <Route path='/home' element={<Home/>}> </Route>
        <Route path='/policy' element={<Policy/>}> </Route>
        <Route path='/Terms' element={<Terms/>}> </Route>        
      </Routes>
    </Router>
  );
}

export default App;
